import React from 'react'
import {RUTA_IMAGEN} from '../../utils/rutasFijas';
import Contador from './Contador';

class Modal extends React.Component {


  //FC: simula el click del boton, tiene un ref en el button
  simulateClick(e) {
      if (e)
        e.click();
    }

  getCuerpo(fancy) {
    if (fancy.tipo === 'imagen') {
      return <img alt="Mensaje de Pedraza" src={`${RUTA_IMAGEN}paquetes/bg/${fancy.imagen}`} className="img-responsive" style={{width: '100%', borderRadius: '1rem'}} />; 
    } else {
      return <iframe title="Video Pedraza" width='560'  height="315" src={fancy.link} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" muted allowfullscreen></iframe>;
    }
  }

render () {
    const { link, mostrarContador, tipo } = this.props.fancy;

    const cuerpo = this.getCuerpo(this.props.fancy);
    
    const linkCuerpo = link && link !== '/' && tipo === 'imagen' && (
      <a href={link}> 
        {cuerpo}
      </a> 
    );

    return (
        <div id="loader" className="loader result">
          <button ref={this.simulateClick} type="button" style={{'display': 'none'}} className="btn btn-primary" data-toggle="modal" data-target="#exampleModalCenter">
            Fancy
          </button>

          <div className="modal fade bd-example-modal-lg" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered " role="document">
              <div className="modal-content"  style={{background: 'none', border: 'none'}}>
                {/* <div className="modal-header">
                  <button type="button" style={{'color':'#fff', 'opacity':'1', 'textShadow':'none' }} className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div> */}
                <div className="modal-body"> 
                 
                  {mostrarContador && <Contador fancy={this.props.fancy} />}
                  
                  { linkCuerpo || cuerpo }
			        	</div> 
               
                
                {/*<div className="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                  </div>
                */}
              </div>
            </div>
          </div>
        </div>
    )}
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Global/Modal.js